<header class="mast-main-head fixed-top" *ngIf="mobileViewSection">
  <nav class="navbar navbar-expand-lg remove-shadow" id="mainNav">
    <div class="container left-header-subscribe">
      <a class="navbar-brand js-scroll-trigger" routerLink="/home"><img src="assets/img/logo.svg"></a>
    </div>
  </nav>
</header>

<header class="masthead" *ngIf="!mobileViewSection">
	<div class="navbar">
		<div class="left-header" style="margin-left: 12px; position: relative">
				<button style="width: 400px;" id="create-workspace" class="back-to-workspace" data-toggle="dropdown" class="DAM-icon">
					<a (click)="backToWorkspace()" class="navbar-brand js-scroll-trigger left-header-backpress" href="javascript:;">
            <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
					    <title>Back</title>
					    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
					        <g id="DAM-Pricing-Copy-2" transform="translate(-40.000000, -28.000000)">
					            <g id="Back" transform="translate(40.000000, 28.000000)">
					                <rect id="Rectangle-8" x="0" y="0" width="24" height="24"></rect>
					                <g id="Group-7" stroke-linecap="round" stroke-linejoin="round" transform="translate(3.000000, 6.000000)" stroke="#000000" stroke-width="1.5">
					                    <line x1="0" y1="6" x2="17.1428571" y2="6" id="Stroke-1"></line>
					                    <polyline id="Path-2" points="5.4 0 0 5.9256575 5.27460736 12"></polyline>
					                </g>
					            </g>
					        </g>
					    </g>
					</svg>
				</a>
				<div class="lib-icon-blue">
					<img src="assets/img/crafttor.png">
				</div>
				<h4 class="content-lib-txt">Feature Requests</h4>
			</button>
		</div>

		<!-- <div class="workspace-left-header">
      <a class="navbar-brand js-scroll-trigger" href="javascript:;" routerLink="/home">
        <img src="assets/img/logo.svg"></a>
        <p (click)="backToWorkspace()">Back to Workspace</p>
    </div> -->

		<div class="right-header">
      <div class="menu-pop-over anticon-bell">
        <a href="javascript:;" class="upgrade-txt" (click)="showUpgradePlans()" *ngIf="userRole == 'Owner' || userRole == 'Admin'">Upgrade</a>
			</div>

			<div class="figma-icons-section">
        <div class="plugin-figma-icon">
          <button (click)="openFigma()" id="notification-pop-over" data-toggle="dropdown" class="anticon-bell-icon">
            <img src="assets/img/ic-figma.png">
          </button>
        </div>

        <div class="plugin-sketch-icon">
          <button (click)="openSketch()" id="notification-pop-over" data-toggle="dropdown" class="anticon-bell-icon">
            <img src="assets/img/ic-sketch.png">
          </button>
        </div>

        <div class="plugin-ai-icon">
          <button (click)="openIllustrator()" id="notification-pop-over" data-toggle="dropdown" class="anticon-bell-icon">
            <img src="assets/img/ai.png" style="width: 20px; height: 20px;">
          </button>
        </div>
      </div>

			<div class="menu-pop-over anticon-bell">
				<button id="notification-pop-over" data-toggle="dropdown" class="anticon-bell-icon" (click)="getNotifications()">
					<img src="assets/img/ic-noti.svg">
				</button>
				<!-- <span class="dot"></span> -->
				<div class="dropdown-menu notification-area" aria-labelledby="notification-pop-over">
						<div class="dropdown-container">
							<h5 class="notification-txt" style="margin-bottom:20px;"><b>Notifications</b></h5>
							<div class="notification-item">

								<div *ngIf="notifications.length == 0" class="empty-notification-area">
									<img src="assets/img/no-noti.svg" alt="">
									<span>You have no notifications</span>
								</div>

								<ul *ngFor="let noti of notifications" style="padding: 0px;">
									<li style="border-bottom: 1px solid rgba(0,0,0,0.1);padding: 16px 0 16px 0;margin: 0 16px;">
										<div class="user-details-info">
										<div class="user-img">
											<span class="ant-avatar ant-avatar-circle ant-avatar-image ant-avatar-icon" style="width: 40px; height: 40px; line-height: 40px; font-size:18px; font-weight: 500;">
												<div class="email-initial-setup" [style.background-color]="getRandomColor()">
													{{getName(noti.firstName)}}{{getName(noti.lastName)}}
												</div>
											</span>
										</div>
										<div>
											<div class="user-info-name">
												<span>{{noti.message}} <b>{{noti.firstName}} {{noti.lastName}}</b></span>
											</div>
											<div class="" style="margin-top: 4px;">
												<span class="notification-date">{{noti.timestamp.toString().split(".")[0]}}</span>
											</div>
										</div>
									</div>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>

			<div class="menu-pop-over user-name" *ngIf="currentUser  && !mobileView">
				<button id="user-pop-over" data-toggle="dropdown" class="user-icon-btn">
					<img *ngIf="!userPic" src="assets/img/user-profile.svg">
					<img *ngIf="userPic" src="{{userPic}}">
				</button>
				<div class="dropdown-menu" aria-labelledby="user-pop-over">
					<div class="dropdown-container">
						<div class="upper-container">
							<div class="name-pro">
								<h6>{{currentUser.firstName+" "+currentUser.lastName}}</h6>
								<span class="pro">
									{{planName}}
								</span>
							</div>
							<div class="email">{{currentUser.email}}</div>
              <div *ngIf="totalSpaceAllowed <= 1000 && consumedSpaceAllowed <= 1000" class="storage-size">{{consumedSpaceAllowed | number: '1.2-2'}}MB / {{totalSpaceAllowed}}GB</div>
              <div *ngIf="totalSpaceAllowed <= 1000 && consumedSpaceAllowed > 1000" class="storage-size">{{consumedSpaceAllowed/1000 | number: '1.2-2'}}GB / {{totalSpaceAllowed}}GB</div>
							<div *ngIf="totalSpaceAllowed > 1000 && consumedSpaceAllowed > 1000" class="storage-size">{{consumedSpaceAllowed/1000 | number: '1.2-2'}}GB / {{totalSpaceAllowed/1000}}TB</div>
							<progress id="file" value="{{consumedSpaceAllowed}}" max="{{totalSpaceAllowedProgress}}"></progress>
						</div>

						<ul class="dropdown-list list-group">
							<div class="hr-line"></div>
							<a routerLink="/my-profile"><li class="list-group-item">My profile</li></a>
							<a (click)="personalClick()"><li class="list-group-item">My content hub</li></a>
							<div class="hr-line"></div>
							<a routerLink="/how-it-works" target="_blank"><li class="list-group-item">How it works</li></a>
							<a routerLink="/home" target="_blank"><li class="list-group-item">Go to Homepage</li></a>
							<a (click)="goToMarketplace()"><li class="list-group-item">Go to Marketplace</li></a>
							<a (click)="goToFeedback()"><li class="list-group-item">Feedback & bugs report</li></a>
							<a routerLink="/faq" target="_blank"><li class="list-group-item">FAQ</li></a>
              <a (click)="goProClick()" *ngIf="planName == 'Free'">
								<li class="list-group-item" style="background-color: var(--primaryColorLightBlue); border-radius: 4px; margin-top: 8px; display: block;"><b style="color: #2d7cff">Upgrade plan:</b><span> You're on the free plan. Upgrade now for unlimited storage, access, members, and more.</span></li>
							</a>
						</ul>
						<div class="logout-btn">
							<button type="button" class="ant-btn" (click)="logOut()"><a>Logout</a></button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</header>

<section class="mobile-view-section" *ngIf="mobileViewSection">
	<div class="container">
		<div class="row">
		  <img src="assets/img/laptop.svg" alt="">
		  <div class="text-container">
		    <h4>Switch to Desktop</h4>
		    <p>Crafttor Workspace is best experienced on desktop. To proceed, Log in from a desktop browser.</p>
		  </div>
		</div>
	</div>
</section>

<section class="feature-request" *ngIf="!mobileViewSection">
  <div class="container">
    <div class="row">
      <div class="main-request-menu">
        <h3 [class.selected]="selectedMenu === 'roadmap'" (click)="selectMenu('roadmap')">
          Roadmap
        </h3>
        <h3 [class.selected]="selectedMenu === 'feature-request'" (click)="selectMenu('feature-request')" style="margin-left: 16px;">
          Feature Requests
        </h3>
      </div>
      <div class="hr-line"></div>
    </div>
  </div>
</section>

<section class="feature-request-details" *ngIf="!mobileViewSection && showRoadMap">
  <div class="container">
    <div class="row">
      <ul class="request-data-ul">
        <li>
          <div class="features-request-data">
            <div class="feature-request-title">
              <h6>In Queue</h6>
            </div>
            <h5>No request. <br>In queue details will come here</h5>
          </div>
        </li>

        <li>
          <div class="features-request-data">
            <div class="feature-request-title">
              <h6>In Progress</h6>
            </div>
            <h5>No request. <br>In progress details will come here</h5>
          </div>
        </li>

        <li>
          <div class="features-request-data">
            <div class="feature-request-title">
              <h6>Done ✅</h6>
            </div>

            <ul>
              <li>
                <div class="round-vote-count">
                  <span>22</span>
                </div>
                <div class="plans-details">
                  <p>Multiple images bulk tags.</p>
                  <span>Feature Request</span>
                </div>
              </li>


              <li>
                <div class="round-vote-count">
                  <span>22</span>
                </div>
                <div class="plans-details">
                  <p>Invite link for users.</p>
                  <span>Feature Request</span>
                </div>
              </li>

              <li>
                <div class="round-vote-count">
                  <span>22</span>
                </div>
                <div class="plans-details">
                  <p>Invite link for users.</p>
                  <span>Feature Request</span>
                </div>
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
  </div>
</section>

<section *ngIf="!mobileViewSection && showFeatureRequests">
  <div class="container">
    <div class="row">
      <div class="request-post">
        <div class="request-box-area">
          <div class="request-box">
            <textarea class="workspace-text-area request-title" #titleArea style="padding: 16px 15px;" id="textarea" placeholder="Request title..." maxlength="40"></textarea>

            <textarea class="workspace-text-area request-desc" #descriptionArea id="textarea" placeholder="Add request description..." maxlength="250"></textarea>
          </div>
          <button *ngIf="!showCreateRequestLoader" (click)="submitFeatureRequest(titleArea.value, descriptionArea.value)" type="button" name="button" class="btn btn-primary">Create request</button>

          <button *ngIf="showCreateRequestLoader" type="button" name="button" class="btn btn-primary"><img src="assets/img/img-up-white.svg" alt="" style="height: 18px;"></button>

        </div>

        <div class="features-request-data">
          <div class="feature-request-title">
            <h6 class="request-list-txt">Requests List</h6>
            <div class="dropdown">
              <button class="dropbtn">Filter</button>
              <div class="dropdown-content">
                <a>Under review</a>
                <a>In queue</a>
                <a>In progress</a>
                <a>Done</a>
              </div>
            </div>
          </div>

          <ul>
            <li>
              <div class="round-vote-count">
                <span>22</span>
              </div>
              <div class="plans-details">
                <p>Multiple images bulk tags.</p>
                <span>Feature Request</span>
              </div>
            </li>


            <li>
              <div class="round-vote-count">
                <span>22</span>
              </div>
              <div class="plans-details">
                <p>Invite link for users.</p>
                <span>Feature Request</span>
              </div>
            </li>

            <li>
              <div class="round-vote-count">
                <span>22</span>
              </div>
              <div class="plans-details">
                <p>Invite link for users.</p>
                <span>Feature Request</span>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>
